import { useEffect, useRef } from 'react';
import './App.scss';
import api from './api/axios';
import { useState } from "react"
import logo from './regulaid-logo.png';

import {
  Award,
  Bookmark,
  CheckSquare,
  Flag,
  Users,
} from "react-feather"
import Skeleton from 'react-loading-skeleton';
import { DashboardLogs } from './components/admin/dashboard-logs';
import { Managers } from './components/admin/managers';
import { AddCustomer } from './components/admin/add-customer';
import { Customers } from './components/admin/customers';
import { Users as UserManagement } from './components/admin/users';
import { LicenseCorrection } from './components/admin/license-correction';
import { Enrollments } from './components/admin/enrollments';

interface DashboardData {
  firstName: string;
  userName: string;
  companyCount: number;
  userCount: number;
}

function Dashboard() {

  const [activeTab, setActiveTab] = useState("managers")
  const [showUserDropdown, setShowUserDropdown] = useState(false)

  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<DashboardData | null>(null);

  const dropdownUserRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownUserRef.current && !dropdownUserRef.current.contains(event.target as Node)) {
        setShowUserDropdown(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  async function fetchData() {
    setLoading(true);

    const response = await api.get('/data');

    if (response.status === 499) {
      setLoading(false);
      return;
    }

    if (response.status !== 200) {
      setLoading(false);
      return;
    }
    setData(response.data);
    setLoading(false);
  }

  async function logout() {
    api.get('/logout');

    window.location.href = "/login";
  }

  useEffect(() => {
    fetchData();
  }, []);

  const getInitials = (fullName: string): string => {
    const names = fullName.trim().split(" ");
    if (names.length === 0) return "";

    const first = names[0][0]?.toUpperCase() ?? "";
    const last = names[names.length - 1][0]?.toUpperCase() ?? "";

    return `${first}${last}`;
  };

  if (loading || !data) {
    return (
      <div className="">
        <div className='top-row'>
          <Skeleton height={150} />
          <Skeleton height={150} />
          <Skeleton height={150} />
          <Skeleton height={150} />
        </div>
        <div className='bottom-row'>
          <Skeleton height={300} />
          <Skeleton height={300} />
        </div>

      </div>);
  }

  return (
    <div className="dashboard">
      {/* Header */}
      <header className="header">
        <img src={logo} alt="Regulaid Logo" className="logo-image" />
        <div className="header-right">
          <div className="dropdown" ref={dropdownUserRef}>
            <button className="avatar-button" onClick={() => setShowUserDropdown(!showUserDropdown)}>
              <div className="avatar">
                <span className="avatar-fallback">{getInitials(data!.userName)}</span>
              </div>
            </button>
          </div>
        </div>
      </header>
      <div className="main-container">
        {/* Main Content */}
        <div className="main-content">
          <div className="page-header">
            <h1 className="page-title">Hallo {data?.firstName},</h1>
          </div>
          <div className='main-content-wrapper'>
            <div className="card-grid">
              <div className="card">
                <div className="card-header" style={{ position: "relative" }}>
                  <Flag className="card-icon" />
                  <h3 className="card-title">Kunden Gesamt</h3>
                </div>
                <div className="card-content">
                  <div className="card-value">{data?.companyCount}</div>
                </div>
              </div>
              <div className="card">
                <div className="card-header">
                  <Users className="card-icon" />
                  <h3 className="card-title">User Gesamt</h3>
                </div>
                <div className="card-content">
                  <div className="card-value">{data?.userCount}</div>
                </div>
              </div>
              {false && <><div className="card">
                <div className="card-header">
                  <Award className="card-icon" />
                  <h3 className="card-title">Zertifizierungen</h3>
                </div>
                <div className="card-content">
                  <div className="card-value">{28}</div>
                </div>
              </div>
                <div className="card">
                  <div className="card-header">
                    <Bookmark className="card-icon" />
                    <h3 className="card-title">Aktive Kurse</h3>
                  </div>
                  <div className="card-content">
                    <div className="card-value">{5}</div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header">
                    <CheckSquare className="card-icon" />
                    <h3 className="card-title">Grundlagenschulung</h3>
                  </div>
                  <div className="card-content">
                    <div className="card-value">{5 + "/" + 10}</div>
                    <div className="progress-container">
                      <div className="progress-bar" style={{ width: (50 + "%") }}></div>
                    </div>
                  </div>
                </div>
              </>}
            </div>

            <div className="tabs-container">
              <div className="tabs">
                <button
                  className={`tab ${activeTab === "managers" ? "active" : ""}`}
                  onClick={() => setActiveTab("managers")}
                >
                  Managers
                </button>
                <button
                  className={`tab ${activeTab === "logs" ? "active" : ""}`}
                  onClick={() => setActiveTab("logs")}
                >
                  Logs
                </button>
                <button
                  className={`tab ${activeTab === "add-customer" ? "active" : ""}`}
                  onClick={() => setActiveTab("add-customer")}
                >
                  Neukundenanlage
                </button>
                <button
                  className={`tab ${activeTab === "customers" ? "active" : ""}`}
                  onClick={() => setActiveTab("customers")}
                >
                  Kunden
                </button>
                <button
                  className={`tab ${activeTab === "users" ? "active" : ""}`}
                  onClick={() => setActiveTab("users")}
                >
                  User
                </button>
                <button
                  className={`tab ${activeTab === "license-correction" ? "active" : ""}`}
                  onClick={() => setActiveTab("license-correction")}
                >
                  Lizenzkorrektur
                </button>
                <button
                  className={`tab ${activeTab === "enrollments" ? "active" : ""}`}
                  onClick={() => setActiveTab("enrollments")}
                >
                  Enrollments
                </button>
              </div>

              {/* Tab Content */}
              <div className="tab-content">
                {activeTab === "logs" && (
                  <div className="tab-pane">
                    <DashboardLogs />
                  </div>
                )}
                {activeTab === "managers" && (
                  <div className="tab-pane">
                    <Managers />
                  </div>
                )}
                {activeTab === "add-customer" && (
                  <div className="tab-pane">
                    <AddCustomer />
                  </div>
                )}
                {activeTab === "customers" && (
                  <div className="tab-pane">
                    <Customers />
                  </div>
                )}
                {activeTab === "users" && (
                  <div className="tab-pane">
                    <UserManagement />
                  </div>
                )}
                {activeTab === "license-correction" && (
                  <div className="tab-pane">
                    <LicenseCorrection />
                  </div>
                )}
                {activeTab === "enrollments" && (
                  <div className="tab-pane">
                    <Enrollments />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dashboard;
